<template>
  <section>
    <div class="col-sm-12 col-md-12 form-group pt-3 mt-2">
      <div class="col-sm-12 col-md-12 form-group text-left pb-0 mb-0">
        <p
          class="text-center text-uppercase"
          style="font-size: 1rem; line-height: 24px"
          :style="template.secondaryTheme ? 'color: white;' : ''"
        >
          Recuperar Senha
        </p>
      </div>

      <p class="col fontMenor text-center" style="word-break: break-word">
        <small :style="template.secondaryTheme ? 'color: white;' : ''">{{
          recoveryDestination
        }}</small>
      </p>

      <!-- Buttons -->
      <div class="col-sm-12 col-md-12 form-group mt-2 pt-2">
        <router-link
          tag="button"
          :to="sso ? 'authorize' : 'login'"
          class="btn-block btn-dark btn shadow-sm"
          :style="primaryBtnStyle"
        >
          <i class="fa fa-caret-left" />

          VOLTAR
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
/* State */
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Email',
  computed: {
    ...mapGetters(['primaryBtnStyle']),
    ...mapState(['template', 'config', 'subdomain', 'sso', 'recoveryDestination']),
    maskedEmail() {
      if (!this.recoveryDestination) return ''

      return this.recoveryDestination.replace(
        /^(.)(.*)(.@.*)$/,
        (_, a, b, c) => a + b.replace(/./g, '*') + c,
      )
    },
  },
}
</script>
